import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PoolMaintenance } from './types';

import { schema } from './utils/schema';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import { ControlledTextField } from 'components/shared';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { useSavePoolMaintenance } from './hooks/useSavePoolMaintenance';

interface Props {
  handleClose: () => void;
  rowData?: PoolMaintenance;
}

export const CreateEditPoolMaintenanceForm: React.FC<Props> = ({
  rowData,
  handleClose
}) => {
  const { t } = useTranslation();

  const methods = useForm({
    defaultValues: schema.cast(rowData),
    resolver: yupResolver(schema)
  });

  const { mutate, isLoading } = useSavePoolMaintenance(handleClose, rowData);

  const onSubmit = async (data) => {
    await mutate(data);
  };

  return (
    <MultiStepForm onSubmit={methods.handleSubmit(onSubmit)} methods={methods}>
      <MultiStepForm.Section
        title={t('basis')}
        validateFields={['code', 'name', 'description']}
      >
        <ControlledTextField
          name="code"
          control={methods.control}
          label={t('poolMaintenance.column.code')}
          variant="outlined"
        />
        <ControlledTextField
          name="name"
          control={methods.control}
          label={t('poolMaintenance.column.name')}
          variant="outlined"
        />
        <ControlledTextField
          name="description"
          control={methods.control}
          label={t('poolMaintenance.column.description')}
          variant="outlined"
        />
      </MultiStepForm.Section>
      <MultiStepForm.Actions>
        <Box display="flex" ml="auto">
          <LoadingButton
            loading={isLoading}
            type="submit"
            variant="contained"
            autoFocus
            color="primary"
          >
            {t('save')}
          </LoadingButton>
        </Box>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};
